import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=d0a74742&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0a74742')) {
      api.createRecord('d0a74742', component.options)
    } else {
      api.reload('d0a74742', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=d0a74742&", function () {
      api.rerender('d0a74742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NT4PYv3D7b24/JS/comp/ImgFallback.vue"
export default component.exports